import { useMutation, useQueryClient } from 'react-query'

import { PortalName } from 'commons/types/enums'
import { setDeviceAsDefault } from '~auth/service/mfa'

export const useSetDefaultDevice = (p: PortalName) => {
  const client = useQueryClient()

  return useMutation((data: { id: number }) => setDeviceAsDefault(p, data.id), {
    onError: (error: Error) => {
      throw error
    },
    onSuccess: async () => {
      await client.invalidateQueries(['tables', 'mfa-devices-table'])
    }
  })
}
